import main from './main'

export class teras extends main{

   constructor (args) {
      super(args)
      this.name = 'www.innsin.it.site'
      this.version = '1.0.1'
      this.urlsite = (process.env.NODE_ENV != 'development') ? document.location.origin + '/site/' : ''
      this.page = {
         title: 'Home'
      }

      this.apiUrl = 'https://api.innsin.it/201806/'
      this.mysql = {
         composer:'db',
         adapter:'innsin',
         database:'sin_inn'
      }
   
      
      this._centro=[]
      super.init()
      return this
   }

 
}
export default new teras
